module.exports = __webpack_public_path__ + "static/8-e062a6073c04c02dd1e3f7ac7198a2be.jpg";